import { __read, __spread } from "tslib";
export function flatten(arr) {
    var _a;
    return (_a = []).concat.apply(_a, __spread(arr));
}
